module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/tactical-training-clan-landing-elite-sm.b0816cb0.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/tactical-training-clan-landing-elite-sm.png
// module id = 3805
// module chunks = 11